import { tv } from "@/utils/tv.config";
import { type VariantProps } from "tailwind-variants";

export const grid2Classes = tv({
  base: "",
  variants: {
    container: {
      true: "grid-root flex flex-row flex-wrap min-w-0 box-border",
      false: "Grid__item basis-auto flex-grow-0 min-w-0 box-border",
    },
    spacing: {
      0: ["gap-0"],
      1: ["gap-1"],
      2: ["gap-2"],
      3: ["gap-3"],
      4: ["gap-4"],
      5: ["gap-5"],
      6: ["gap-6"],
      7: ["gap-7"],
      8: ["gap-8"],
      9: ["gap-9"],
      10: ["gap-10"],
      11: ["gap-11"],
      12: ["gap-12"],
      16: ["gap-16"],
      20: ["gap-20"],
      24: ["gap-12"],
    },
    rowSpacing: {
      0: ["gap-y-0"],
      1: ["gap-y-1"],
      2: ["gap-y-2"],
      3: ["gap-y-3"],
      4: ["gap-y-4"],
      5: ["gap-y-5"],
      6: ["gap-y-6"],
      7: ["gap-y-7"],
      8: ["gap-y-8"],
      9: ["gap-y-9"],
      10: ["gap-y-10"],
      11: ["gap-y-11"],
      12: ["gap-y-12"],
      16: ["gap-y-16"],
      20: ["gap-y-20"],
      24: ["gap-y-12"],
    },
    columnSpacing: {
      0: ["gap-x-0"],
      1: ["gap-x-1"],
      2: ["gap-x-2"],
      3: ["gap-x-3"],
      4: ["gap-x-4"],
      5: ["gap-x-5"],
      6: ["gap-x-6"],
      7: ["gap-x-7"],
      8: ["gap-x-8"],
      9: ["gap-x-9"],
      10: ["gap-x-10"],
      11: ["gap-x-11"],
      12: ["gap-x-12"],
      16: ["gap-x-16"],
      20: ["gap-x-20"],
      24: ["gap-x-12"],
    },
    // size: {
    //   1: "w-[calc(theme(width.1/12)-(12-1)*(var(--Grid-spacing)*4px/12))]",
    //   2: "w-[calc(theme(width.2/12)-(12-2)*(var(--Grid-spacing)*4px/12))]",
    //   3: "w-[calc(theme(width.3/12)-(12-3)*(var(--Grid-spacing)*4px/12))]",
    //   4: "w-[calc(theme(width.4/12)-(12-4)*(var(--Grid-spacing)*4px/12))]",
    //   5: "w-[calc(theme(width.5/12)-(12-5)*(var(--Grid-spacing)*4px/12))]",
    //   6: "w-[calc(theme(width.6/12)-(12-6)*(var(--Grid-spacing)*4px/12))]",
    //   7: "w-[calc(theme(width.7/12)-(12-7)*(var(--Grid-spacing)*4px/12))]",
    //   8: "w-[calc(theme(width.8/12)-(12-8)*(var(--Grid-spacing)*4px/12))]",
    //   9: "w-[calc(theme(width.9/12)-(12-9)*(var(--Grid-spacing)*4px/12))]",
    //   10: "w-[calc(theme(width.10/12)-(12-10)*(var(--Grid-spacing)*4px/12))]",
    //   11: "w-[calc(theme(width.11/12)-(12-11)*(var(--Grid-spacing)*4px/12))]",
    //   12: "w-[calc(theme(width.full)-(12-12)*(var(--Grid-spacing)*4px/12))]",
    // },
    direction: {
      row: "flex-row",
      "row-reverse": "flex-row-reverse",
      column: "flex-col",
      "column-reverse": "flex-col-reverse",
    },
    wrap: {
      nowrap: "flex-nowrap",
      "wrap-reverse": "flex-wrap-reverse",
      wrap: "flex-wrap",
    },
    align: {
      start: "items-start",
      center: "items-center",
      end: "items-end",
    },
    justify: {
      start: "justify-start",
      center: "justify-center",
      end: "justify-end",
      between: "justify-between",
      around: "justify-around",
    },
  },
});

//After removal of tailwind-variant responsiveVariant feature
export const grid2Size = tv({
  base: [],
  variants: {
    size: {
      1: "w-[calc(theme(width.1/12)-(12-1)*(var(--Grid-spacing)*4px/12))]",
      2: "w-[calc(theme(width.2/12)-(12-2)*(var(--Grid-spacing)*4px/12))]",
      3: "w-[calc(theme(width.3/12)-(12-3)*(var(--Grid-spacing)*4px/12))]",
      4: "w-[calc(theme(width.4/12)-(12-4)*(var(--Grid-spacing)*4px/12))]",
      5: "w-[calc(theme(width.5/12)-(12-5)*(var(--Grid-spacing)*4px/12))]",
      6: "w-[calc(theme(width.6/12)-(12-6)*(var(--Grid-spacing)*4px/12))]",
      7: "w-[calc(theme(width.7/12)-(12-7)*(var(--Grid-spacing)*4px/12))]",
      8: "w-[calc(theme(width.8/12)-(12-8)*(var(--Grid-spacing)*4px/12))]",
      9: "w-[calc(theme(width.9/12)-(12-9)*(var(--Grid-spacing)*4px/12))]",
      10: "w-[calc(theme(width.10/12)-(12-10)*(var(--Grid-spacing)*4px/12))]",
      11: "w-[calc(theme(width.11/12)-(12-11)*(var(--Grid-spacing)*4px/12))]",
      12: "w-[calc(theme(width.full)-(12-12)*(var(--Grid-spacing)*4px/12))]",
    },
  },
});

export type Grid2Variants = VariantProps<typeof grid2Classes>;
